export default __webpack_public_path__ + "static/media/calendar.b5ec24be.svg";